export enum LoadState {
  Loading = "loading",
  Success = "success",
  Error = "error",
}
